import { render, staticRenderFns } from "./mailRegister.vue?vue&type=template&id=f0543a2e&"
import script from "./mailRegister.vue?vue&type=script&lang=js&"
export * from "./mailRegister.vue?vue&type=script&lang=js&"
import style0 from "./mailRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports